export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'lead-countries-major-crops-population';
export const REPORT_APE_ID = 'lead-countries-major-crops-population-ape';

export const CATEGORIES_AXIS = "countries.default";
export const SERIES_AXIS = "calendar.default";